import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import clsx from "clsx";
import { FILTER_TYPES } from "constants/discovery";
import { modalTypes } from "constants/types";
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { applyFilter } from "slices/discovery/actions/filters";
import { fetchUniqueItemsCount } from "slices/discovery/actions/theme";
import { setFilterDocID } from "slices/discovery/discoverySlice";
import { selectDocuments } from "slices/discovery/selectors";
import { getImage } from "utils";
import handleKeyboardClick from "utils/handleKeyboardClick";

const SelectDocumentModal = () => {
  const dispatch = useDispatch();

  const documents = useSelector(selectDocuments);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);

  const closeModal = () => {
    dispatch(hideModal(modalTypes.SELECT_DOCUMENT));
  };

  const handleDocumentClick = (id) => {
    setSelectedDocumentId(id);
  };

  const handleConfirmClick = () => {
    closeModal();
    dispatch(setFilterDocID(selectedDocumentId));
    dispatch(applyFilter(FILTER_TYPES.GAPS_RELATIVE_TO_A_REFERENCE_DOC));
    dispatch(
      fetchUniqueItemsCount(
        FILTER_TYPES.GAPS_RELATIVE_TO_A_REFERENCE_DOC,
        selectedDocumentId
      )
    );
  };

  const handleCancelClick = () => {
    closeModal();
  };

  return (
    <Modal
      show
      centered
      backdrop
      className="fade-in discovery_select_document_modal"
      onDismiss={closeModal}
    >
      <Modal.Header>
        <b>Gaps relative to single document</b>
      </Modal.Header>
      <Modal.Body>
        <div className="discovery_select_document_modal__note">
          Choose the document:
        </div>
        <ul className="discovery_select_document_modal__document_list">
          {documents.map(({ Id, Name }) => {
            return (
              <li
                key={Id}
                className={clsx(
                  "discovery_select_document_modal__document_list__document",
                  { selected: Id === selectedDocumentId }
                )}
                onClick={() => handleDocumentClick(Id)}
                onKeyDown={handleKeyboardClick(() => handleDocumentClick(Id))}
              >
                <img src={getImage(Name)} alt="document-icon" />
                {Name}
              </li>
            );
          })}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <NewButton variant={NewButtonVariant.l2} onClick={handleCancelClick}>
          Cancel
        </NewButton>

        <NewButton
          variant={NewButtonVariant.l1}
          disabled={selectedDocumentId === null}
          onClick={handleConfirmClick}
        >
          Confirm
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default SelectDocumentModal;
